var exports = {
  "iE": "xaee3c4fa--ba6ea6--wrapper",
  "il": "xaee3c4fa--ba6ea6--rules-wrapper",
  "Rf": "xaee3c4fa--ba6ea6--heading-wrapper",
};

module.exports = exports;
